import { createFileRoute } from '@tanstack/react-router'

import { checkinQuery, conflictsQuery, flagsQuery, productsQuery } from '../lib/queries'
import { More } from '../screens/More'

export const Route = createFileRoute('/more')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(productsQuery()),
      context.queryClient.ensureQueryData(conflictsQuery()),
      context.queryClient.ensureQueryData(checkinQuery('weekly')),
      context.queryClient.ensureQueryData(flagsQuery()),
    ]),
  component: More,
})
